import { OrgModelsPage } from "@/components/profile/org-models-page.tsx";
import { m } from "@/paraglide/messages.js";
import { createFileRoute } from "@tanstack/react-router";
import { pageTitle } from "@/utils/page-title.ts";

export const Route = createFileRoute("/_authenticated/settings/org/models")({
	component: OrgModelsPage,
	// The page owns the whole settings pane (pane header + its own scroller)
	// instead of the nav-derived title column.
	staticData: { settingsLayout: "full" },
	head: () => ({
		meta: [{ title: pageTitle(m.admin_settings_models_tab()) }],
	}),
});
